import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  width: "16",
  height: "16",
  viewBox: "0 0 14 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M0.25 2.5C0.25 1.25736 1.25736 0.25 2.5 0.25H9.04535C9.64208 0.25 10.2144 0.487053 10.6363 0.90901L13.091 3.36366C13.5129 3.78562 13.75 4.35792 13.75 4.95465V11.5C13.75 12.7426 12.7426 13.75 11.5 13.75H2.5C1.25736 13.75 0.25 12.7426 0.25 11.5V2.5ZM2.5 1.75C2.08579 1.75 1.75 2.08579 1.75 2.5V11.5C1.75 11.9142 2.08579 12.25 2.5 12.25H2.875V10.75C2.875 9.50736 3.88236 8.5 5.125 8.5H8.875C10.1176 8.5 11.125 9.50736 11.125 10.75V12.25H11.5C11.9142 12.25 12.25 11.9142 12.25 11.5V4.95465C12.25 4.75574 12.171 4.56498 12.0303 4.42432L9.57568 1.96967C9.43502 1.82902 9.24426 1.75 9.04535 1.75H8.5V3.25C8.5 4.49264 7.49264 5.5 6.25 5.5H5.5C4.25736 5.5 3.25 4.49264 3.25 3.25V1.75H2.5ZM4.75 1.75V3.25C4.75 3.66421 5.08579 4 5.5 4H6.25C6.66421 4 7 3.66421 7 3.25V1.75H4.75ZM8.875 10C9.28921 10 9.625 10.3358 9.625 10.75V12.25H4.375V10.75C4.375 10.3358 4.71079 10 5.125 10H8.875Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = {
  key: 1,
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_4 = /*#__PURE__*/_createVNode("path", {
  d: "M5 2.5C3.61929 2.5 2.5 3.61929 2.5 5V15C2.5 16.3807 3.61929 17.5 5 17.5H5.41667V14.1667C5.41667 12.786 6.53595 11.6667 7.91667 11.6667H12.0833C13.464 11.6667 14.5833 12.786 14.5833 14.1667V17.5H15C16.3807 17.5 17.5 16.3807 17.5 15V7.72739C17.5 7.06435 17.2366 6.42847 16.7678 5.95963L14.0404 3.23223C13.5715 2.76339 12.9356 2.5 12.2726 2.5H11.6667V5.83333C11.6667 7.21405 10.5474 8.33333 9.16667 8.33333H8.33333C6.95262 8.33333 5.83333 7.21405 5.83333 5.83333V2.5H5Z",
  fill: "white"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("path", {
  d: "M7.5 2.5V5.83333C7.5 6.29357 7.8731 6.66667 8.33333 6.66667H9.16667C9.6269 6.66667 10 6.29357 10 5.83333V2.5H7.5Z",
  fill: "white"
}, null, -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("path", {
  d: "M12.9167 14.1667V17.5H7.08333V14.1667C7.08333 13.7064 7.45643 13.3333 7.91667 13.3333H12.0833C12.5436 13.3333 12.9167 13.7064 12.9167 14.1667Z",
  fill: "white"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.fill)
    ? (_openBlock(), _createBlock("svg", _hoisted_1, [
        _hoisted_2
      ]))
    : (_openBlock(), _createBlock("svg", _hoisted_3, [
        _hoisted_4,
        _hoisted_5,
        _hoisted_6
      ]))
}